export enum FuelCardProvider {
  EFS = 'EFS'
}

export interface FuelCardConfig {
  fuelcardProvider: FuelCardProvider;
  tenantId: string;
  divisionId: string;
  credentials: FuelCardCredential[];
}

export interface FuelCardCredential {
  username: string;
  password: string;
}

export interface FuelCardConfigResponse {
  fuelcardProvider: FuelCardProvider;
  tenantId: string;
  divisionId: string;
  username: string;
  password: string;
}

export interface FuelCardConfigTableData {
  username: string;
  fuelcardProvider: FuelCardProvider;
  lastSync?: string;
  actions?: React.ReactNode;
}

export interface CreateFuelCardConfigParams {
  divisionId: string;
  fuelcardProvider: FuelCardProvider;
  username: string;
  password: string;
  tenantId: string;
}

export interface DeleteFuelCardConfigParams {
  divisionId: string;
  fuelcardProvider: FuelCardProvider;
  username: string;
}

export enum FuelCardSyncStatus {
  SUCCESS = 'success',
  FAILED = 'fail'
}

export interface FuelCardSyncRawResponse {
  lastSuccess: Date;
  updated_at: Date;
  user: string;
  division: string;
  status: FuelCardSyncStatus;
  provider: string;
}

export interface FuelCardSyncStatusResponse {
  lastSuccess: Date;
  updated_at: Date;
  username: string;
  divisionId: string;
  status: FuelCardSyncStatus;
  provider: FuelCardProvider;
}


export interface FuelCardResponse {
  status: string;
  cards: FuelCard[];
}

export interface FuelCard {
  id: string;
  card_number: string;
  driver_id: string;
  provider: FuelCardProvider;
  truck_id: string;
}